module.exports = __webpack_public_path__ + "static/img/medal1.8278491.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/4/medal1.png
// module id = lqu9
// module chunks = 1